<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="mask">
        <rect x="0" y="0" width="14" height="16" fill="white"/>
        <circle cx="8.5" cy="11.5" r="6" fill="black"/>
      </mask>
    </defs>
    <circle id="front" cx="8.5" cy="11.5" r="4" fill="currentColor"/>
    <circle id="back" cx="5.5" cy="4.5" r="4" mask="url(#mask)" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'SettingsIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '16',
    },
    viewBox: {
      type: String,
      default: '0 0 14 16',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
